const RECENT_MEMBER_ACTIVITY_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

export const getRecentMemberActivityCutoffIso = (referenceDate = new Date()) =>
  new Date(referenceDate.getTime() - RECENT_MEMBER_ACTIVITY_WINDOW_MS).toISOString();

export const isRecentMemberActivity = (
  createdAt?: string | null,
  referenceDate = new Date(),
) => {
  if (!createdAt) {
    return false;
  }

  const createdAtTime = new Date(createdAt).getTime();
  if (Number.isNaN(createdAtTime)) {
    return false;
  }

  return createdAtTime >= referenceDate.getTime() - RECENT_MEMBER_ACTIVITY_WINDOW_MS;
};
